import axiosInstance from "../AxiosInstance";
import { GET_ERROR_GROUPS, GET_ERROR_GROUP_DETAIL } from "./ErrorTelemetryEndpoints";

export function getErrorGroups(currentPage, limit) {
  return axiosInstance.get(GET_ERROR_GROUPS + `?page=${currentPage}&limit=${limit}`);
}

export function getErrorGroupDetail(id, page, limit) {
  return axiosInstance.get(GET_ERROR_GROUP_DETAIL + `?_id=${id}&page=${page}&limit=${limit}`);
}
